
const Session = (function () {
    const setCookie = (cname, cvalue) => {
        const d = new Date();
        if (cvalue === '') d.setTime(d.getTime() - (360 * 24 * 60 * 60 * 1000));
        else d.setTime(d.getTime() + (360 * 24 * 60 * 60 * 1000));
        let expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/;SameSite=Lax;secure;';
    };
    const getCookie = (cname) => {
        let name = cname + '=';
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    };
    const value = (key) => {
        return localStorage.getItem(key) || '';
    };

    const object = (key) => {
        const val = localStorage.getItem(key) || '';
        if (!val) return null;
        try {
            return JSON.parse(val);
        } catch (e) {
            return null;
        }
    };

    const setValue = (key, value) => {
        localStorage.setItem(key, value);
    };
    const setObject = (key, value) => {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (e) {
            if (e.name === 'QuotaExceededError' || e.message.includes('quota')) {
                console.warn(`LocalStorage quota exceeded when saving key: ${key}. Skipping storage.`);
                // We purposefully do NOT clear localStorage here to avoid deleting critical state
                // (like template editor data, subjects, or routing information).
                // Massive objects like 'school' and 'objects' simply won't be cached offline.
            } else {
                console.error('LocalStorage setObject error:', e);
            }
        }
    };

    const push = (key, value) => {
        let item = localStorage.getItem(key);
        let obj = [];
        if (item) {
            obj = JSON.parse(item);
        }
        obj.push(value);
        try {
            localStorage.setItem(key, JSON.stringify(obj));
        } catch (e) {
            if (e.name === 'QuotaExceededError') {
                console.warn('LocalStorage quota exceeded in push, truncating...');
                // Keep only the last 100 entries to stay within quota
                obj = obj.slice(-100);
                obj.push(value);
                try {
                    localStorage.setItem(key, JSON.stringify(obj));
                } catch (retryErr) {
                    console.error('LocalStorage push failed:', retryErr);
                }
            } else {
                console.error('LocalStorage push error:', e);
            }
        }
    };
    const alert = (value) => {
        let item = localStorage.getItem('alerts');
        let obj = [];
        if (item) {
            obj = JSON.parse(item);
        }
        obj.push(value);
        localStorage.setItem('alerts', JSON.stringify(obj));
    };

    const hasAlert = () => {
        const items = localStorage.getItem('alerts');
        if (!items) {
            return false;
        }
        const obj = JSON.parse(items);
        if (obj.length >= 1) return true;
        return false;
    };

    const remove = (key) => {
        localStorage.removeItem(key);
    };

    const clear = () => {
        const exclude = ['LINKS'];
        const saved = [];
        exclude.forEach(el => {
            saved.push({ name: el, value: localStorage.getItem(el) });
        });
        localStorage.clear();
        saved.map(el => {
            localStorage.setItem(el.name, el.value);
        });
        setCookie('user', '');
        setCookie('x-refresh-token', '');
        setCookie('x-access-token', '');
    };
    const clearMin = () => {
        const exclude = ['LINKS'];
        const saved = [];
        exclude.forEach(el => {
            saved.push({ name: el, value: localStorage.getItem(el) });
        });
        localStorage.clear();
        saved.map(el => {
            localStorage.setItem(el.name, el.value);
        });
    };

    const secureValue = (key) => {
        return getCookie(key);
    };
    const secureRemove = (key) => {
        setCookie(key, '');
    };
    const setSecureValue = (key, value) => {
        setCookie(key, value);
    };

    const secureObject = (key) => {
        const obj = getCookie(key);
        if (!obj) return '';
        return JSON.parse(obj);
    };


    const setSecureObject = (key, value) => {
        const obj = JSON.stringify(value);
        setCookie(key, obj);
    };


    const showAlert = (str = '') => {
        if (str && str.length > 10) {
            alert(str);
        }
        window.showAlert();
    };



    return {
        setCookie,
        value,
        object,
        setValue,
        setObject,
        push,
        alert,
        remove,
        clear,
        clearMin,
        hasAlert,
        secureValue,
        secureObject,
        secureRemove,
        setSecureValue,
        setSecureObject,
        showAlert
    };

})();

if (!Session.object('LINKS')) {
    Session.setObject('LINKS', {
        "bookshelf": "https://bookclub.mysyllabux.com/",
        "cdn": "https://cdn.mysyllabux.com/",
        "school": "https://school.mysyllabux.com/",
        "homepage": "https://mysyllabux.com/",
        "parent": "https://parent.mysyllabux.com/",
        "student": "https://student.mysyllabux.com/"
    })
}

export default Session;